import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Navigation } from "lucide-react";
import { BUSINESS, mapsDirUrl, mapsSearchUrl } from "../../config/business";
import { SERVICES } from "../../config/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-deep text-white overflow-hidden" data-testid="footer">
      {/* watermark */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-center overflow-hidden opacity-[0.06] select-none">
        <span className="font-head font-extrabold text-[16vw] leading-none whitespace-nowrap text-white">
          SMOG HUT
        </span>
      </div>

      <div className="section relative z-10 py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="inline-flex bg-white rounded-xl p-2.5 shadow-sm">
            <img src="/logo.webp" alt="Smog Hut Modesto — Smog and Registration" className="h-14 w-auto" />
          </div>
          <p className="mt-4 text-sm text-white/70 leading-relaxed">STAR certified smog checks, diesel testing, repairs and DMV registration — fast, honest service for Modesto & Ceres.</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href={mapsSearchUrl()} target="_blank" rel="noreferrer" className="inline-flex items-start gap-2 hover:text-cta"><MapPin className="h-4 w-4 mt-0.5" />{BUSINESS.address.full}</a></li>
            <li><a href={`tel:${BUSINESS.phoneTel}`} className="inline-flex items-center gap-2 hover:text-cta"><Phone className="h-4 w-4" />{BUSINESS.phoneDisplay}</a></li>
            <li><a href={`mailto:${BUSINESS.email}`} className="inline-flex items-center gap-2 hover:text-cta"><Mail className="h-4 w-4" />{BUSINESS.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-head font-bold text-sm uppercase tracking-wider text-white/60">Hours</h4>
          <ul className="mt-4 space-y-1.5 text-sm">
            {BUSINESS.hours.map((h) => (
              <li key={h.day} className="flex items-center justify-between gap-4 text-white/80">
                <span className="inline-flex items-center gap-2"><Clock className="h-3.5 w-3.5 text-cta" />{h.day}</span>
                <span>{h.open ? `${to12(h.open)}–${to12(h.close)}` : "Closed"}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-head font-bold text-sm uppercase tracking-wider text-white/60">Services</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-white/80 hover:text-cta">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-head font-bold text-sm uppercase tracking-wider text-white/60">Areas We Serve</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {BUSINESS.cities.map((c) => (
              <li key={c.slug}>
                <Link to={`/locations/${c.slug}`} className="text-white/80 hover:text-cta">Smog Check {c.name}</Link>
              </li>
            ))}
          </ul>
          <a href={mapsDirUrl()} target="_blank" rel="noreferrer" className="btn-cta mt-4 !py-2.5">
            <Navigation className="h-4 w-4" /> Get Directions
          </a>
        </div>
      </div>

      <div className="relative z-10 border-t border-white/10">
        <div className="section py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/70 font-body">
          <p>© Copyright © {year} {BUSINESS.name} | All Rights Reserved · Fast STAR Smog Checks in Modesto & Ceres, CA</p>
          <a href="https://shineinfosolutions.com" target="_blank" rel="noreferrer" className="text-cta font-head font-bold uppercase tracking-wide hover:underline" data-testid="dev-credit">Designed &amp; Developed by ShineInfoSolutions.com</a>
        </div>
      </div>
    </footer>
  );
}

function to12(t) {
  const [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  const hh = h % 12 === 0 ? 12 : h % 12;
  return `${hh}${m ? ":" + String(m).padStart(2, "0") : ""} ${ap}`;
}
